import React from "react"
import { useQueryState } from "../../hooks"

/**
 * @description Allows to wrap a component with a HOC that use useRsqlQuery hook
 * @returns {function} a HOC
 */
export default BaseComponent => props => {
  const { query, handlers } = useQueryState()
  const { filter } = query
  const { setQuery } = handlers
  return (
    <BaseComponent
      {...props}
      query={filter ? { query: filter } : {}}
      queryPagination={query}
      setQuery={setQuery}
    />
  )
}
